import { StyledText } from '../../atoms/Text/StyledText';
import { StyledPayAllElementHeader } from '../../atoms/UserPanelAllTrainerPay/StyledPayAllElementHeader';
import { getString } from '../../../strings';

const TableHeader = () => {
    return (
        <StyledPayAllElementHeader>
            <div>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                    hasdeclaredpadding="0 4px 2px 4px"
                >
                    {getString('Trainings_trainings_all_trainer_pay_trener')}
                </StyledText>
            </div>
            <div>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                    hasdeclaredpadding="0 4px 2px 4px"
                >
                    {getString('Trainings_trainings_all_trainer_pay_godziny')}
                </StyledText>
            </div>
            <div>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                    hasdeclaredpadding="0 4px 2px 4px"
                >
                    {getString('Trainings_trainings_all_trainer_pay_wyplata')}
                </StyledText>
            </div>
            <div>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                    hasdeclaredpadding="0 4px 2px 4px"
                >
                    {getString('Trainings_trainings_all_trainer_pay_dochod')}
                </StyledText>
            </div>
            <div>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                    hasdeclaredpadding="0 4px 2px 4px"
                >
                    {getString('Trainings_trainings_all_trainer_pay_przychod')}
                </StyledText>
            </div>
        </StyledPayAllElementHeader>
    );
};

export default TableHeader;
